export default __webpack_public_path__ + "static/media/08_nakladani-sazenic.184bf2ab.jpg";